import { Pipe, PipeTransform } from '@angular/core';
import { PlatformMarkup } from '@app/features/pricing-and-availability';

@Pipe({
  standalone: true,
  name: 'findMarkupByChannel',
})
export class FindMarkupByChannelPipe implements PipeTransform {
  transform(platformMarkups: PlatformMarkup[], channel: string): string {
    if (!platformMarkups || platformMarkups.length === 0) {
      return '';
    }

    // A little magic required to normalise Airbnb Official channel
    // string for markups as they share the same channel string
    // as the original airbnb integration.
    if (channel === 'airbnb-official') {
      channel = 'airbnb';
    }

    const value = platformMarkups.find((x) => x.platform === channel);

    if (!value) {
      return '';
    }

    return (value.markup * 100).toString();
  }
}
